import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ChartPersonService {

  constructor(private http:HttpClient) { }



  Add(chart_id: number,
    person_id: number):Observable<any>{
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {
      id:0,
      person_id:person_id,
      chart_id:chart_id,
      Token: ''
    }
    return this.http.post(environment.BaseUrl + "Daro/ChartPerson/Add",body,{headers}).pipe(
        map(data=>{
          return data as any
        })
    )

  }

  Delete(Id: number): Observable<any>{
    return this.http.get(environment.BaseUrl + "Daro/ChartPerson/Delete?id="+Id).pipe(
      map(data=>{
        return data as any
      })
    )
  }

}
